import * as React from "react";

import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Paths from "@tunnel-enums/index";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import UsersLists from "@tunnel-components/@sharded/@widgets/users/lists/component";
import * as Lodash from "lodash";
import VirtualPagination from "@tunnel-components/@sharded/@widgets/virtualized/pagination";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  // desturation

  const {
    usersData,
    totalElements,
    itemsPerPage,
    onUpdateCurrentPageNumber,
    currentPageNumbers,
    rightdata,
    onIsMail,
    onIsRoles,
    onIsLogin,
    isMail,
    isRoles,
    isLogin,
    loading,
    errorserver,
    errorUpdateUser,
    someInputUpdateError,
    emailUpdateError,
    addUsersError,
    someInputError,
    emailError,
    onSubmitUser,
    nameUserAdd,
    loginUserAdd,
    firstNameUserAdd,
    emailUserAdd,
    roleUserAdd,
    onChangeRoleUserAdd,
    roleError,
    nameError,
    firstnameError,
    loginError,
    /*onChangeUser*/ removeUserObject,
    onChangeRoleUser,
    usersHasBeenFound,
    onSubmitUpdateUser,
    onChangeUpdateUser,
    onRemouve,
    onUpdate,
    onOpenAction,
    usersArray,
    btnloading,
    onOpenAddUser,
    addUsers,
    onUpdateUser,
    onRemouveUser,
    updateUser,
    remouveuser,
  } = props;
  ///  Simple Authorization + some operations
  //
  /**
   * @description :
   * l'utilisateur qui est connecter
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description :
   * la possiblilité de créer un utilisateur
   * @const
   * @name User
   * @type { any  }
   */
  const addusers: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERSADDED,
  ]);
  /**
   * a callback method to define yourself depending on what you want
   * to do with your data. This method is the core of your list,
   * it is here that you define what will be rendered thanks to your data
   */
  const rowRenderer = ({ index, key, style }: any) => {
    /**
     * @constant
     * @description :
     * @name  items
     * @types any[]
     */
    const items: any[] = [];
    /**
     * @constant
     * @description :
     * @name  fromIndex
     * @types number
     */
    const fromIndex: number = index;
    /**
     * @constant
     * @description :
     * @name  toIndex
     * @types number
     */
    const toIndex: number = Math.min(fromIndex + 1, usersData.length);
    {
      /** Boucle */
    }
    for (let i = fromIndex; i < toIndex; i++) {
      {
        /** Création du tableau des items */
      }

      items.push(
        <UsersLists
          key={i}
          onIsMail={onIsMail(i)}
          onIsRoles={onIsRoles(i)}
          onIsLogin={onIsLogin(i)}
          isMail={isMail[i]}
          isRoles={isRoles[i]}
          isLogin={isLogin[i]}
          index={i}
          item={!!usersData[i] && usersData[i]}
          onUpdateUser={onUpdate(usersData[i])}
          onChange={onOpenAction(i)}
          onRemouveUser={onRemouve(usersData[i])}
          usersArray={usersArray[i]}
        />
      );
    }
    return (
      <div
        key={key}
        style={{
          ...style,
          width: "100%",
        }}
      >
        {items}
      </div>
    );
  };
  /**
   * @description : retourne un string hexadecimanl ( couleur)
   * @const
   * @name fill
   * @type { string  }
   */
  // const fill: string = "#007ADF";
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      error={errorserver}
      loading={loading}
      errorUpdateUser={errorUpdateUser}
      roleError={roleError}
      nameError={nameError}
      firstnameError={firstnameError}
      loginError={loginError}
      someInputUpdateError={someInputUpdateError}
      emailUpdateError={emailUpdateError}
      someInputError={someInputError}
      addUsersError={addUsersError}
      rightdata={rightdata}
      emailError={emailError}
      nameUserAdd={nameUserAdd}
      loginUserAdd={loginUserAdd}
      firstNameUserAdd={firstNameUserAdd}
      emailUserAdd={emailUserAdd}
      roleUserAdd={roleUserAdd}
      onChangeRoleUserAdd={onChangeRoleUserAdd}
      onChangeUser={onChangeUpdateUser}
      onSubmitUser={onSubmitUser}
      onChangeRoleUser={onChangeRoleUser}
      removeUserObject={removeUserObject}
      userObject={usersHasBeenFound}
      onSubmitUpdateUser={onSubmitUpdateUser}
      onChangeUpdateUser={onChangeUpdateUser}
      btnloading={btnloading}
      onUpdateUser={onUpdateUser}
      onRemouveUser={onRemouveUser}
      updateUser={updateUser}
      remouveuser={remouveuser}
      addUsers={addUsers}
      onOpenAddUser={onOpenAddUser}
    >
      <section className="tunnel-site animated fadeIn">
        <BreadCrumb
          links1={Paths.PathsNamesEnums.USERS}
          width="26"
          height="26"
          iconAdministration={true}
          title={i18next.t("administration")}
          breadText1={i18next.t("utilisateurs")}
          UsersAdd={addusers}
          onOpenAddUser={onOpenAddUser}
        />
        <div className="contentAllSiteWithoutOnglet">
          <section className="columnsWithoutOngletForArray">
            <section className="arrays">
              {!Lodash.isEmpty(usersData) && !!usersData && (
                <section className="arraysHeader">
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{
                      cursor: "default",
                      minWidth: "unset",
                      width: "2.5%",
                    }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default", minWidth: "unset" }}>
                          {i18next.t("N°")}
                        </p>
                      </div>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{
                      cursor: "default",
                      minWidth: "unset",
                      width: "17%",
                    }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }}>
                          {i18next.t("login")}
                        </p>
                      </div>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{
                      cursor: "default",
                      minWidth: "unset",
                      width: "15%",
                    }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }}>{i18next.t("nom")}</p>
                      </div>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{
                      cursor: "default",
                      minWidth: "unset",
                      width: "15%",
                    }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }}>
                          {i18next.t("prenom")}
                        </p>
                      </div>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{
                      cursor: "default",
                      minWidth: "unset",
                      width: "22%",
                    }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }}>
                          {i18next.t("email")}
                        </p>
                      </div>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{
                      cursor: "default",
                      minWidth: "unset",
                      width: "20%",
                    }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default" }}>{i18next.t("role")}</p>
                      </div>
                    </div>
                  </span>
                  <span
                    className="arraysHeaderSpanAuto"
                    style={{
                      cursor: "default",
                      minWidth: "unset",
                      width: "8.5%",
                    }}
                  >
                    <div className="arraysHeaderContenair">
                      <div className="arrayHeaderInfos">
                        <p style={{ cursor: "default", minWidth: "unset" }} />
                      </div>
                    </div>
                  </span>
                </section>
              )}

              {totalElements && itemsPerPage && (
                <VirtualPagination
                  classnames="incident-items with-1-columns" // la classe
                  width="100%" //
                  heightView="100%" // hauteur et largeur de la fenètre
                  rowHeight={53} // Hauteur de la cellule
                  arrayContent={!Lodash.isEmpty(usersData)} // Boolean vérifie si le tableau est vide
                  rowRenderer={rowRenderer} // élement JSX , column
                  itemPerPage={itemsPerPage} // nombre d'élement par page
                  totalItemLength={totalElements} // nombre total d'élement
                  currentPageNumbers={currentPageNumbers} // la page courante
                  onUpdateCurrentPageNumbers={onUpdateCurrentPageNumber} // fonction de mise à jour de la page courante
                  itemPerRow={1}
                  totalRowElements={usersData.length + 2}
                  widthView="100%" //
                />
              )}
            </section>
          </section>
        </div>
      </section>
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  btnloading?: any;
  errorserver?: any;
  usersData?: any;
  totalElements?: any;
  itemsPerPage?: any;
  onUpdateCurrentPageNumber?: any;
  currentPageNumbers?: any;
  onOpenAddUser?: any;
  addUsers?: any;
  onUpdateUser?: any;
  onRemouveUser?: any;
  updateUser?: any;
  remouveuser?: any;
  usersArray?: any;
  onOpenAction?: any;
  usersList?: any;
  item?: any;
  onUpdate?: any;
  onRemouve?: any;
  usersHasBeenFound?: any;
  onSubmitUpdateUser?: any;
  onChangeUpdateUser?: any;
  removeUserObject?: any;
  onChangeRoleUser?: any;
  onChangeUser?: any;
  onSubmitUser?: any;
  nameUserAdd?: any;
  firstNameUserAdd?: any;
  emailUserAdd?: any;
  roleUserAdd?: any;
  onChangeRoleUserAdd?: any;
  loginUserAdd?: any;
  someInputError?: any;
  emailError?: any;
  someInputUpdateError?: any;
  emailUpdateError?: any;
  errorUpdateUser?: boolean;
  addUsersError?: any;
  roleError?: any;
  nameError?: any;
  firstnameError?: any;
  loginError?: any;
  usersupdatedactioncreator?: string;
  userscreatedactioncreator?: string;
  usersloadedactioncreator?: string;
  usersremovedactioncreator?: string;
  onIsMail?: any;
  onIsRoles?: any;
  onIsLogin?: any;
  isMail?: any;
  isRoles?: any;
  isLogin?: any;
  rightdata?: any;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/administration/users/component.tsx